import React, { useRef, useEffect, useContext } from "react";
import { AppContext } from "@component/AppProvider";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";

import _CFG from "@config/defaults";

const Footer = () => {
    const { site } = useContext(AppContext);

    if (site.footer) {
        return parse(site.footer);
    }

    return <Fragment />;
};

export default Footer;
